import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Es difícil de seguir?',
  a: 'No, son solo 2 días con instrucciones precisas y claras. No hay conjeturas ni planes complicados.'
}, {
  q: '¿Necesito suplementos caros?',
  a: 'No, solo agua e ingredientes base de cocina que probablemente ya tienes o puedes conseguir en cualquier supermercado por muy poco dinero.'
}, {
  q: '¿Tendré que pasar todo el día en el baño?',
  a: 'Eliminarás más líquido de lo normal porque tu cuerpo está purgando la retención, pero no es un laxante; puedes hacer tu vida normal y salir de casa sin problema.'
}, {
  q: '¿Puedo tomar café?',
  a: 'Sí, en el manual te enseñamos la forma correcta de hacerlo sin que el café dispare tu cortisol y te inflame.'
}, {
  q: '¿Qué pasa si tengo un evento el fin de semana?',
  a: 'Este es el protocolo perfecto para usar justo antes de un evento. Te ayudará a lucir menos hinchada, sentirte más ligera y que tu ropa te quede mejor.'
}, {
  q: '¿Es seguro para mayores de 60?',
  a: 'Sí, está diseñado específicamente para metabolismos maduros que ya no responden a dietas convencionales o restricciones extremas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-white px-4" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <h2 className="font-serif text-3xl md:text-4xl text-brand-dark mb-12 text-center" data-id="element-3">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-4">
          {faqs.map((faq, index) => <div key={index} className={`border rounded-xl overflow-hidden transition-all duration-300 ${openIndex === index ? 'border-brand-teal bg-brand-tealLight/30' : 'border-gray-200 hover:border-brand-teal/50'}`} data-id="element-5">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-6">
                <span className="font-bold text-lg text-brand-dark pr-8" data-id="element-7">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-teal transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-8" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-9">
                <p className="text-brand-dark/80 text-lg leading-relaxed" data-id="element-10">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}